// IM-EXT-003 IM-UI-043 — Descoberta de fontes no site: sugestões que só viram fonte com confirmação (com edição) ou são rejeitadas.
import { useState } from 'react';
import { useToast } from './Toast';
import { INTEGRATION_LABEL, intelApi } from '../data/intel';

type Any = any;  
const KIND: Record<string, string> = { rss: 'Feed RSS/Atom', atom: 'Feed RSS/Atom', page: 'Página', youtube: 'YouTube', social: 'Rede social' };

export function SourceDiscovery({ defaultUrl = '', companyName, targetId, onChanged }: { defaultUrl?: string; companyName?: string; targetId?: string; onChanged?: () => void }) {
  const toast = useToast();
  const [url, setUrl] = useState(defaultUrl);
  const [name, setName] = useState(companyName ?? '');
  const [busy, setBusy] = useState(false);
  const [items, setItems] = useState<Any[] | null>(null);
  const [notes, setNotes] = useState<string[]>([]);
  const [edit, setEdit] = useState<Record<string, string>>({});
  const discover = async () => {
    setBusy(true);
    try { const r = await intelApi.discover({ url, companyName: name || undefined, targetId }); setItems(r.items); setNotes(r.notes); }
    catch (e) { toast((e as Error).message, 'error'); } finally { setBusy(false); }
  };
  const decide = async (s: Any, decision: 'ACCEPT' | 'REJECT') => {
    try {
      const r = await intelApi.decideSuggestion(s.id, { decision, ...(edit[s.id] && edit[s.id] !== s.url ? { url: edit[s.id] } : {}), ...(name ? { accountName: name } : {}) });
      setItems((xs) => (xs ?? []).map((x) => (x.id === s.id ? r : x)));
      toast(decision === 'ACCEPT' ? 'Fonte cadastrada.' : 'Sugestão rejeitada.');
      onChanged?.();
    } catch (e) { toast((e as Error).message, 'error'); }
  };
  return (
    <div className="discovery">
      <div className="form-grid">
        <label className="field"><span>Site da empresa</span><input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="empresa.com.br" /></label>
        <label className="field"><span>Empresa</span><input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome usado nos sinais" /></label>
      </div>
      <div className="form-actions"><button className="secondary" onClick={discover} disabled={busy || url.trim().length < 4}>{busy ? 'Lendo o site…' : 'Descobrir fontes no site'}</button></div>
      {notes.map((n) => <p key={n} className="notice-inline">{n}</p>)}
      {items && (items.length === 0 ? <p className="card-sub">Nenhuma fonte encontrada.</p> : (
        <ul className="suggestion-list">
          {items.map((s) => (
            <li key={s.id}>
              <div><span className="tag mint">{KIND[s.kind] ?? s.kind}</span> <b>{s.label}</b> <span className="cell-sub">confiança {s.confidence.toLowerCase()}{s.kind === 'social' ? ` · ${INTEGRATION_LABEL.CREDENCIAL_AUSENTE}` : ''}</span></div>
              {s.status === 'PENDING' ? (
                <div className="suggestion-actions">
                  <input aria-label="Endereço da fonte" value={edit[s.id] ?? s.url} onChange={(e) => setEdit({ ...edit, [s.id]: e.target.value })} />
                  <button className="chip" onClick={() => decide(s, 'ACCEPT')}>Confirmar</button>
                  <button className="chip" onClick={() => decide(s, 'REJECT')}>Rejeitar</button>
                </div>
              ) : <span className="cell-sub">{s.status === 'ACCEPTED' ? 'Confirmada — virou fonte' : 'Rejeitada'} · {s.url}</span>}
            </li>
          ))}
        </ul>
      ))}
    </div>
  );
}
